import React, { useEffect, useMemo } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import { useVersionStore } from 'store/version.store';

import { ICardCluster, useQueryGetCardClusterFilter } from 'api/queries/getCardClusterFilter.query';

import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

type Option = {
    id?: number;
    value: string;
    label: string;
};

interface ITagsFilterProps {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: string;
    options?: ICardCluster[];
    isSelected?: boolean;
    versionId?: number;
}

export const ClusterFilter = ({
    methods,
    name,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
    versionId,
}: ITagsFilterProps) => {
    const { data, isSuccess } = useQueryGetCardClusterFilter({
        metaDataId: versionId,
    });

    const options: Option[] = useMemo(() => {
        return (
            data?.map((option) => {
                return {
                    id: option?.value,
                    value: option.value.toString(),
                    label: option.label,
                };
            }) ?? []
        );
    }, [data]);

    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady || !isSuccess) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: isSuccess });
    }, [value, name, filtersStatusRef, isSuccess]);

    const handleChange = (selectedOption: ISelectOption<string>) => {
        methods?.setValue(name, selectedOption ? selectedOption.value : null);
        handleFilters && handleFilters();
    };

    const handleValue = (value) => {
        if (!value) {
            return null;
        }
        return options?.find((item) => item.value.toString() === value) || null;
    };

    return isSelected ? (
        <div data-testid={'battlecards-filters-cluster'} className={classes.selectWrapper}>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<number>>
                        {...field}
                        options={options}
                        id={'battlecards-cluster'}
                        value={handleValue(value)}
                        onChange={handleChange}
                        isClearable={true}
                        label={FilterLabels.cluster}
                    />
                )}
                name={name}
                control={methods?.control}
            />
        </div>
    ) : null;
};
